interface LabelStatusCustomProps {
  backgroundColor?: string; // class background
  textColor?: string; // class text
  content?: string;
  typeRadius?: "rounded-full" | "rounded";
}

export const LabelStatusCustom = ({
  backgroundColor = "bg-gray-200",
  textColor = "text-black",
  content,
  typeRadius = "rounded-full",
}: LabelStatusCustomProps) => {
  return (
    <div
      className={`flex items-center justify-center gap-2 py-1 px-3 ${typeRadius} ${backgroundColor} ${textColor}`}
    >
      <span className="text-xs font-medium">{content}</span>
    </div>
  );
};
